import React from 'react';
import { Link } from 'react-router-dom';

const Logo = ({children, className, noclick}) => (
  noclick !== true ? <Link to="/" className={(className || '') + " shor-logo"}>Shor</Link>
  : <span className={(className || '') + " shor-logo"}>Shor</span>
)

export default Logo;


// WEBPACK FOOTER //
// ./src/components/Logo.js